module.exports = __webpack_public_path__ + "img/icon-btn-green.cd7f4d4e.svg";